import { render } from "./registrationChild.vue?vue&type=template&id=c9f61190&scoped=true"
import script from "./registrationChild.vue?vue&type=script&lang=js"
export * from "./registrationChild.vue?vue&type=script&lang=js"

import "./registrationChild.vue?vue&type=style&index=0&id=c9f61190&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9f61190"]])

export default __exports__